export default __webpack_public_path__ + "static/media/Long_LightBlue.faa604e3.png";